
                export default function (Component) {
                    Component.__source = "library/components/VabSideBar/index.vue"
                }
            